import gsap from 'gsap';
import { CustomEase } from 'gsap/CustomEase';

gsap.registerPlugin(CustomEase);

const selectors = {
  root: '[data-slider-fraction]',
  current: '[data-slider-fraction-current]'
};

const outDuration = 0.35;
const inDuration = 0.65;

CustomEase.create('slider-fraction-out', '0.62, 0.05, 0.01, 0.99');
CustomEase.create('slider-fraction-in', 'M0,0 C0.4,1,0.75,1,1,1');

/**
 * The number rolls like a slot reel: the old digit leaves upwards while a new
 * one arrives from below, both clipped by the slot. The incoming digit takes
 * almost twice as long on a decelerating ease, so it settles after the old one
 * is gone instead of the two sliding as one block.
 */

function initSliderFraction(root) {
  let current = root.querySelector(selectors.current);

  if (!current) {
    return;
  }

  const slot = current.parentNode;

  function setValue(value) {
    const next = String(value);

    if (current.textContent === next) {
      return;
    }

    const outgoing = current;
    const incoming = document.createElement('span');

    incoming.className = 'slider-fraction__current';
    incoming.setAttribute('data-slider-fraction-current', '');
    incoming.textContent = next;

    gsap.set(incoming, { yPercent: 110 });
    slot.appendChild(incoming);

    gsap.to(outgoing, {
      yPercent: -110,
      duration: outDuration,
      ease: 'slider-fraction-out',
      onComplete: () => outgoing.remove()
    });

    gsap.to(incoming, {
      yPercent: 0,
      duration: inDuration,
      ease: 'slider-fraction-in'
    });

    current = incoming;
  }

  root.dispatchEvent(new CustomEvent('slider-fraction:ready', {
    bubbles: true,
    detail: { setValue }
  }));
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll(selectors.root).forEach(initSliderFraction);
});
